import React from 'react'
import {NotificationDTO} from '../../../../generated/api'
import GenericNotificationDisplay from './GenericNotificationDisplay'

const GuildCreationNotification = ({notification}: {notification: NotificationDTO}) => (
    <GenericNotificationDisplay notification={notification} title={'Guild creation'} canClose={true} />
)

export default GuildCreationNotification